module.exports = __webpack_public_path__ + "img/recruit-icon-1.bd9e889c.png";